import { useGetUrl } from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Divider, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { ExternalLink } from 'src/components/ExternalLink/ExternalLink';
import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useAppConfig } from 'src/modules/appConfig';

import translations from './.vocab';
import { PoweredBySeekPassSvg } from './PoweredBySeekPass';

export const PoweredBySeekPassFooter: FC = () => {
  const { t } = useTranslations(translations);
  const { zone, language } = useAppConfig();
  const getUrl = useGetUrl(zone, language);

  const { seekPassLearnMoreClicked } = useAnalytics();

  return (
    <Stack space="large">
      <Divider />
      <PoweredBySeekPassSvg />
      <Text tone="secondary">
        {t(
          'SEEK Pass is a trustworthy and 100% SEEK-owned platform. Your information will be securely stored on SEEK Pass.',
        )}
      </Text>
      <Text weight="strong">
        {t('Learn more', {
          ExternalLink: (v) => (
            <ExternalLink
              target="_blank"
              rel="noopener noreferrer"
              weight="weak"
              hitArea="large"
              onClick={seekPassLearnMoreClicked}
              href={getUrl('what-is-seek-pass')}
            >
              {v}
            </ExternalLink>
          ),
        })}
      </Text>
    </Stack>
  );
};
